import React from 'react';
import Zoom from 'react-reveal/Zoom';

const initialState = {
    subscriberEmail: "",
    subscriberFname: "",
    subscriberLname: "",
    isSubmitted: 0,
    isLoading: false,
};

class SubscribeInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = initialState;
        this.onChange = this.onChange.bind(this);
        this.onChangeFname = this.onChangeFname.bind(this);
        this.onChangeLname = this.onChangeLname.bind(this);
        this.submitSubscribe = this.submitSubscribe.bind(this);
    }

    onChange(e) {
        this.setState({ subscriberEmail: e.target.value });
    }

    onChangeFname(e) {
        this.setState({ subscriberFname: e.target.value });
    }

    onChangeLname(e) {
        this.setState({ subscriberLname: e.target.value });
    }

    async submitSubscribe(e) {
        if (e && e.preventDefault) e.preventDefault();
        if (this.state.isLoading) return;

        this.setState({ isLoading: true });

        try {
            const res = await fetch('/.netlify/functions/subscribe', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    email: this.state.subscriberEmail,
                    firstname: this.state.subscriberFname,
                    lastname: this.state.subscriberLname,
                }),
            });
            const json = await res.json().catch(() => ({}));

            if (json.success) {
                this.setState({ isLoading: false, isSubmitted: 1 });
            } else if (json.code === 'duplicate') {
                this.setState({ isLoading: false, isSubmitted: 2 });
            } else if (json.code === 'invalid') {
                this.setState({ isLoading: false, isSubmitted: 3 });
            } else {
                this.setState({ isLoading: false, isSubmitted: 3 });
            }
        } catch (err) {
            this.setState({ isLoading: false, isSubmitted: 3 });
        }
    }

    render() {
        return (
            <Zoom>
                <div>

                    {this.state.isSubmitted === 0 ?

                        <form onSubmit={this.submitSubscribe} style={{ display: "inline-flex" }}>
                            <input type="text" defaultValue="" placeholder="Enter your First Name" onChange={this.onChangeFname} className="first-name" />
                            <input type="text" defaultValue="" placeholder="Enter your Last Name" onChange={this.onChangeLname} className="last-name" />
                            <input type="email" defaultValue="" placeholder={this.props.placeholder} onChange={this.onChange} className="subscription-field" />
                            <button type="submit" name="button" className="subscribe-button">
                                {this.state.isLoading ?
                                    <div className="loader"></div> : this.props.buttonText
                                }
                            </button>
                        </form> : null
                    }

                    {
                        this.state.isSubmitted === 1 ?

                            <p style={{ fontSize: '18px' }}>Thank You! Please check your 'Promotions', 'Junk' or 'Spam' folder for our welcome e-mail. We don't want you to miss it :)</p> : null
                    }

                    {
                        this.state.isSubmitted === 2 ?

                            <p style={{ fontSize: '18px' }}>Oops! It seems we already have you on our list. Please check your 'Promotions', 'Junk' or 'Spam' folder for our e-mails.</p> : null
                    }

                    {
                        this.state.isSubmitted === 3 ?

                            <div>
                                <form onSubmit={this.submitSubscribe} style={{ display: "inline-flex" }}>
                                    <input type="email" defaultValue="" placeholder={this.props.placeholder} onChange={this.onChange} className="subscription-field" />
                                    <button type="submit" name="button" className="subscribe-button">
                                        {this.state.isLoading ?
                                            <div className="loader"></div> : this.props.buttonText
                                        }
                                    </button>
                                </form>
                                <p style={{ fontSize: '18px' }}>Please enter a valid email address.</p>
                            </div> : null
                    }
                </div>
            </Zoom>

        );
    }
}

export default SubscribeInput;
